export const SPECS = {
  ProductPageBlocksWishlistSSR: 'specs.stores.ProductPageBlocksWishlistSSR',
  EnablePanoramaIntegration:
    'specs.stores.ProductPageBlocksEnablePanoramaIntegration',
};
